import React from "react"
import { FooterMenuFieldsFragment, HeaderMenuFieldsFragment } from "../../../graphql-types"
import * as styles from "./website-map.module.scss"

type RenderProps = {
  menuData: HeaderMenuFieldsFragment & FooterMenuFieldsFragment
}

const WebsiteMap: React.FC<RenderProps> = ({ menuData }) => {
  const buildWebsiteMapMenu = (mainMenuLabel: string, mainMenuPage, submenu) => {
    const shouldDisplaySubmenu = (submenuItem): boolean => {
      return submenuItem.page && (submenuItem.headerDisplay || submenuItem.footerDisplay)
    }

    return (
      <li className={styles.menu}>
        {mainMenuPage && mainMenuPage.slug ? (
          <a className={styles.mainMenuLabel} href={`/${mainMenuPage.slug}`}>
            {mainMenuLabel}
          </a>
        ) : (
          <a className={styles.mainMenuLabel} href="#">
            {mainMenuLabel}
          </a>
        )}
        {submenu &&
          submenu.filter(shouldDisplaySubmenu).map(submenuItem => (
            <a key={submenuItem.id} className={styles.submenulabel} href={`/${submenuItem.page.slug}`}>
              {submenuItem.label}
            </a>
          ))}
      </li>
    )
  }

  return (
    <ul className={styles.websiteMap}>
      {menuData.menuSection.map(menuSection => (
        (menuSection.headerDisplay || menuSection.footerDisplay) &&
          buildWebsiteMapMenu(menuSection.label, menuSection.page, menuSection.subMenu)
      ))}
    </ul>
  )
}

export default WebsiteMap
